import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { getContext } from 'svelte';

var root_1 = $.from_html(`<div class="absolute top-full left-0 mt-1 w-full z-50 rounded-md border bg-popover p-1 shadow-md"><!></div>`);

export default function Select_content($$anchor, $$props) {
	$.push($$props, true);

	const select = getContext('select');
	const isOpen = $.derived(() => select.isOpen());
	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var div = root_1();
			var node_1 = $.child(div);

			$.snippet(node_1, () => $$props.children ?? $.noop);
			$.reset(div);
			$.append($$anchor, div);
		};

		$.if(node, ($$render) => {
			if ($.get(isOpen)) $$render(consequent);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsic2VsZWN0LWNvbnRlbnQuc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCI+XG4gIGltcG9ydCB7IGdldENvbnRleHQgfSBmcm9tICdzdmVsdGUnO1xuXG4gIGxldCB7XG4gICAgY2hpbGRyZW4sXG4gIH06IHtcbiAgICBjaGlsZHJlbj86IGFueTtcbiAgfSA9ICRwcm9wcygpO1xuXG4gIGNvbnN0IHNlbGVjdCA9IGdldENvbnRleHQ8e1xuICAgIGlzT3BlbjogKCkgPT4gYm9vbGVhbjtcbiAgfT4oJ3NlbGVjdCcpO1xuXG4gIGNvbnN0IGlzT3BlbiA9ICRkZXJpdmVkKHNlbGVjdC5pc09wZW4oKSk7XG48L3NjcmlwdD5cblxueyNpZiBpc09wZW59XG4gIDxkaXYgY2xhc3M9XCJhYnNvbHV0ZSB0b3AtZnVsbCBsZWZ0LTAgbXQtMSB3LWZ1bGwgei01MCByb3VuZGVkLW1kIGJvcmRlciBiZy1wb3BvdmVyIHAtMSBzaGFkb3ctbWRcIj5cbiAgICB7QHJlbmRlciBjaGlsZHJlbj8uKCl9XG4gIDwvZGl2Plxuey9pZn1cbiJdLCJtYXBwaW5ncyI6Ijs7U0FDVyxVQUFVLFFBQVEsUUFBUTs7OzswREFEckMsQ0FBQzs7O09BU08sTUFBTSxHQUFHLFVBQVUsQ0FFdEIsUUFBUTtPQUVMLE1BQU0sbUJBQVksTUFBTSxDQUFDLE1BQU07Ozs7Ozs7Ozs7Ozs7OzthQUdsQyxNQUFNOzs7Ozs7QUFGWixDQUFDIn0=